type BillingSourceInput = {
  owner?: any;
  currentUser?: any;
};

const hasPlanHistory = (source: any) =>
  Array.isArray(source?.planhistory) && source.planhistory.length > 0;

export const resolveBillingSource = ({ owner, currentUser }: BillingSourceInput) => {
  const userBilling = currentUser?.userBilling;
  if (userBilling && typeof userBilling === "object" && hasPlanHistory(userBilling)) {
    return userBilling;
  }

  const ownerUserBilling = owner?.userBilling;
  if (ownerUserBilling && typeof ownerUserBilling === "object" && hasPlanHistory(ownerUserBilling)) {
    return ownerUserBilling;
  }

  if (hasPlanHistory(owner)) {
    return owner;
  }

  if (userBilling && typeof userBilling === "object") {
    return userBilling;
  }

  if (ownerUserBilling && typeof ownerUserBilling === "object") {
    return ownerUserBilling;
  }

  return owner || {};
};
